<template>
  <v-card
    @dragover.prevent="dragover"
    @dragleave.prevent="dragleave"
    @drop.stop.prevent="drop">
    <v-card-title class="primary px-0">
      <v-toolbar flat color="transparent">
        <v-select solo flat hide-details
          v-model="store.type"
          color="secondary"
          append-outer-icon="fal fa-angle-right"
          :items="getTypeItems"
          :disabled="isLoading"
          @change="changeType"
        />
        <v-select solo flat hide-details
          v-model="store.company"
          color="secondary"
          append-outer-icon="fal fa-angle-right"
          :items="getCompanyItems"
          :disabled="isLoading"
          @change="changeCompany"
        />
        <v-select solo flat hide-details
          v-model="store.folder"
          color="secondary"
          append-outer-icon="fal fa-angle-right"
          :items="getFolderItems"
          :loading="isLoading"
        />
        <v-select solo flat hide-details
          v-model="store.tag"
          color="secondary"
          :items="getBranchItems"
        />
      </v-toolbar>
    </v-card-title>
    <v-card-text :class="[ isDropping ? 'secondary' : 'grey', 'lighten-4' ]">
      <v-row align="center" justify="center" style="height:300px;">
        <v-col cols="12">
          <v-row align="center" justify="center">
            <v-col v-if="!isUploading" align="center" justify="center" class="py-0">
              <v-btn depressed
                color="secondary"
                :disabled="!isUploadable"
                @click.stop="$refs.fileInputer.click()">
                <v-icon small class="mr-2">fal fa-upload</v-icon>ファイルを選択する
              </v-btn>
              <input type="file" ref="fileInputer"
                style="display:none;"
                @change="upload($event.target.files)"
              />
            </v-col>
            <v-col v-else align="center" justify="center" class="py-0">
              <v-progress-circular
                :rotate="-90"
                :size="100"
                :width="15"
                :value="printUploadedRatio"
                color="secondary">{{ printUploadedRatio }}%</v-progress-circular>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col align="center" justify="center" :class="[{ 'grey--text text--lighten-4': !isDropping }]">アップロードを開始します</v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn text color="secondary" @click="close">閉じる</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
const DEF = {
  FORM: {
    book: {
      sheet: 1
    },
    max: 200,
  }
}
export default {
  name: 'authorBbookUploadFiler',
  props: [ 'books' ],
  data () {
    return {
      config: {
        status: {
          loading: false,
          dropping: false,
          uploading: -1
        }
      },
      meta: {
        types: {
          bank: '通帳',
          card: 'カード'
        }
      },
      store: {
        type: '',
        company: '',
        tag: '',
        folder: '',
        folders: []
      },
      form: {
        max: DEF.FORM.max,
        book: {
          sheet: DEF.FORM.book.sheet
        }
      }
    }
  },
  methods: {
    init: function (req) {
      const { type, company, folder } = req || {}
      this.$set(this.store, 'type', type)
      this.$set(this.store, 'company', company)
      this.$set(this.store, 'folder', folder)
      this.$set(this.store, 'tag', this.$store.getters['author/get']('belong'))
      this.$nextTick(() => {
        this.submit({ type: 'folders' })
      })
    },
    close: function () {
      this.$emit('close')
    },
    changeType: function () {
      const { type } = this.store
      if (type) {
        const company = this.$props.books && this.$props.books[type]
        const names = Object.keys(company)
        this.$set(this.store, 'company', names[0])
        this.$nextTick(() => {
          this.changeCompany()
        })
      }
    },
    changeCompany: function () {
      this.submit({ type: 'folders' })
    },
    upload: function (req) {
      if (req.length) {
        this.submit({ type: 'preview', file: req[0] })
      }
      this.$set(this.config.status, 'dropping', false)
    },
    dragover: function () {
      this.$set(this.config.status, 'dropping', this.store.type && this.store.company && this.store.folder)
    },
    dragleave: function () {
      this.$set(this.config.status, 'dropping', false)
    },
    drop: function (e) {
      if (
        e &&
        e.dataTransfer &&
        e.dataTransfer.files &&
        e.dataTransfer.files.length
      ) {
        if (this.store.type && this.store.company && this.store.folder) {
          this.upload(e.dataTransfer.files)
        }
      }
    },
    preSubmit: function (token, req) {
      const { type, file } = req || {}
      const { bid } = this.$props.books[this.store.type][this.store.company]
      const urls = {
        folders: `${this.$url.api}box/get/client/folder/${bid}`,
        preview: `${this.$url.api}bbook/preview/xlsx`
      }
      const fds = {
        folders: {},
        preview: new FormData()
      }
      if (type === 'preview') {
        fds.preview.append('file', file)
        fds.preview.append('type', this.store.type)
        fds.preview.append('mid', this.store.folder)
        fds.preview.append('company', this.store.company)
        fds.preview.append('cfg', JSON.stringify(this.form))
      }
      const opts = {
        default: {
          headers: {
            'firebase-token': token
          }
        },
        preview: {
          headers: {
            'content-type': 'multipart/form-data',
            'firebase-token': token
          },
          onUploadProgress: (e) => {
            let per = e.loaded / e.total
            this.$set(this.config.status, 'uploading', Math.round(per * 100))
          }
        }
      }
      if (type && urls[type] && fds[type]) {
        this.$set(this.config.status, 'loading', true)
        if (type === 'preview') {
          this.$set(this.config.status, 'uploading', 0)
        }
        return { type, url: urls[type], fd: fds[type], option: opts[type] || opts.default }
      } else {
        return false
      }
    },
    submit: function (req) {
      this.$firebase.auth().currentUser.getIdToken(true).then(token => {
        const dt = this.preSubmit(token, req)
        if (dt) {
          const { url, fd, type, option } = dt
          this.axios.post(url, fd, option).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit(res.data.data, type)
            } else {
              this.failSubmit(res.data && res.data.data, type)
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        }
      })
    },
    postSubmit: function (req, submitType) {
      const type = submitType || ''
      if (type === 'folders') {
        const thisYear = this.$moment().format('YYYY')
        const newItems = (req && req.length) ? req.map(it => { return it }).sort((a, b) => {
          return a.name > b.name ? -1 : 1
        }) : []
        if (!newItems.length || !newItems.map(it => { return it.name }).includes(thisYear)) {
          newItems.unshift({
            id: 'new',
            name: thisYear
          })
        }
        if (!newItems || !newItems.length || !newItems.map(it => { return it.id }).includes(this.store.folder)) {
          this.$set(this.store, 'folder', newItems[0].id)
        }
        this.$set(this.store, 'folders', newItems)
        this.$set(this.config.status, 'loading', false)
      } else if (type === 'preview') {
        this.$set(this.config.status, 'loading', false)
        this.$set(this.config.status, 'uploading', -1)
        this.$emit('load', Object.assign(req, {
          dest: {
            mid: this.store.folder,
            tag: this.store.tag
          }
        }))
      }
    },
    failSubmit: function (req, submitType) {
      this.$set(this.config.status, 'loading', false)
      if (submitType === 'preview') {
        this.$set(this.config.status, 'uploading', -1)
        const body = req.response && req.response.body
        const { code } = body || {}
        const err = this.$error.box.file.upload[code] || ''
        if (err) {
          this.$store.dispatch('notifier/addAlert', {
            title: 'アップロード失敗',
            message: err
          })
        }
      }
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isDropping () {
      return this.config.status.dropping
    },
    isUploadable () {
      return this.store.type && this.store.company && this.store.folder && this.store.tag
    },
    isUploading () {
      return this.config.status.uploading !== -1
    },
    printUploadedRatio () {
      return this.config.status.uploading
    },
    getTypeItems () {
      return Object.keys(this.meta.types).map(key => {
        return {
          text: this.meta.types[key],
          value: key
        }
      })
    },
    getCompanyItems () {
      return (this.$props.books && this.$props.books[this.store.type]) ? Object.keys(this.$props.books[this.store.type]).map(key => {
        return {
          text: this.$props.books[this.store.type][key].label,
          value: key
        }
      }) : []
    },
    getFolderItems () {
      return this.store.folders.length ? this.store.folders.map(it => {
        return {
          text: it.name,
          value: it.id
        }
      }) : []
    },
    getBranchItems () {
      return Object.keys(this.$mango.areaSlugs).map(key => {
        return {
          value: key,
          text: this.$mango.areaSlugs[key]
        }
      })
    }
  }
}
</script>